<template>
  <dx-popup
    v-model:visible="popupVisibleMainAsset"
    :drag-enabled="true"
    :hide-on-outside-click="false"
    :min-width="500"
    :show-close-button="true"
    :show-title="true"
    height="90vh"
    shading-color="rgba(0,0,0,0.05)"
    title="Справочник ОС"
    width="80vw"
  >
    <div class="d-flex flex-column h-100">
      <mped-amortization-main-asset-view
        v-if="popupVisibleMainAsset"
        :choose-item="true"
        :selection-mode="selectionMode"
        @selected-item="selectedItem($event)"
        />
    </div>
  </dx-popup>
</template>

<script>
export default {
  name: 'mped-amortization-main-asset-chooser',
};
</script>

<script setup>
import { defineExpose, ref, defineEmits, defineProps } from 'vue';

import { DxPopup } from 'devextreme-vue/popup';
import MpedAmortizationMainAssetView
  from '@/views/mped/views/amortization/main-asset/mped-amortization-main-asset-view.vue';

const popupVisibleMainAsset = ref(false);

const emit = defineEmits(['selectedItem']);

const { selectionMode } = defineProps({
  selectionMode: {
    type: String,
    default: 'single',
  }
});

const Open = () => {
  popupVisibleMainAsset.value = true;
}

const selectedItem = (e) => {
  emit('selectedItem', e);
  popupVisibleMainAsset.value = false;
}

defineExpose({
  Open,
});

</script>

<style scoped>

</style>
